<div class="w-full min-h-screen bg-white overflow-x-clip relative">
  <app-error-modal
    [isOpen]="showAlert"
    [type]="'warning'"
    [message]="messageAlert()"
    (send)="navigateToProfile()"
    (close)="closeAlert()"
    [buttonLabel]="hasNotVerify() ? 'Cerrar': needsGoogleCalendar() ? 'Conectar' : 'Ir al perfil'"
  ></app-error-modal>
  <app-menu></app-menu>
  <router-outlet />
  <app-footer></app-footer>
</div>
<!-- <div class="mouseCursor cursor-outer"></div>
<div class="mouseCursor cursor-inner">
  <span><i class="tji-angle-left"></i>Drag<i class="tji-angle-right"></i></span>
</div> -->
<app-user-data-modal [isOpen]="isOpenUserModal()" (saved)="isOpenUserModal.set(false)"></app-user-data-modal>